<template>
  <div class="unauthorized">
    <div class="description">使用前微信要求您的授权，请点击下方使用完整服务后继续。。。</div>
  </div>
</template>
<script>
export default {
  name: 'unauthorized',
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.unauthorized{
  width: 100%;
  height: 100%;
  background-color: #eeeeee;
  display: flex;
  align-items: center;
  justify-content: center;

    .description{
      text-align: center;
      padding: 0 20px;
      font-size: 30px;
      color: #333;
      line-height: 60px;
    }

}
</style>
